import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-check-check-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 7 17l-5-5"/><path d="m22 10-9.3 9.3-2.2-2.2"/></svg>`
})
export class CheckCheckIconComponent {}
